import DatePresetRows from "./DatePresetRows";
import { ListSubheader } from "@mui/material";
import {
  reportsV3DynamicDatePresetGroups,
  reportsV3DynamicDatePresets,
} from "config";
import * as labels from "config.labels";
import React from "react";
import * as staticDataHooks from "store/hooks/staticDataHooks";

const DynamicDatePresetSection = ({ selectedName, onSelect }) => {
  const translateLabels = staticDataHooks.useTranslator("uiLabels");
  const groups = reportsV3DynamicDatePresetGroups();
  const presets = reportsV3DynamicDatePresets();
  const inGroup = (group) => presets.filter((preset) => preset.group === group);
  const rows = [
    {
      group: groups.LAST,
      label: translateLabels(labels.REPORTS_V3_DATE_FILTER_ROW_LAST, {
        default: "Last",
      }),
    },
    {
      group: groups.THIS,
      label: translateLabels(labels.REPORTS_V3_DATE_FILTER_ROW_THIS, {
        default: "This",
      }),
    },
    {
      group: groups.NEXT,
      label: translateLabels(labels.REPORTS_V3_DATE_FILTER_ROW_NEXT, {
        default: "Next",
      }),
    },
    {
      group: groups.TO_DATE,
      label: translateLabels(labels.REPORTS_V3_DATE_FILTER_ROW_TO_DATE, {
        default: "To date",
      }),
    },
  ].map((row) => ({ ...row, presets: inGroup(row.group) }));
  return (
    <React.Fragment>
      <ListSubheader disableSticky>
        {translateLabels(labels.REPORTS_V3_DATE_FILTER_DYNAMIC_HEADING, {
          default: "Dynamic filters",
        })}
      </ListSubheader>
      <DatePresetRows
        rows={rows}
        isSelected={(preset) => preset.defaultLabel === selectedName}
        onSelect={onSelect}
      />
    </React.Fragment>
  );
};

export default DynamicDatePresetSection;
